import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

export interface Props {
  queryKey: string;
  IdUsuarioLider?: string;
  PalavraChave?: string;
  PaginaAtual?: number;
  TotalItensRetorno?: number;
  enabled?: boolean;
}

export function useCarometro(props: Props) {
  const fetchData = async () => {
    const verifyIdUsuarioLider = props.IdUsuarioLider
      ? `&IdUsuarioLider=${props.IdUsuarioLider}`
      : "";
    const verifyPalavraChave = props.PalavraChave
      ? `&PalavraChave=${props.PalavraChave}`
      : "";
    const verifyPaginaAtual = props.PaginaAtual
      ? `&PaginaAtual=${props.PaginaAtual}`
      : "";
    const verifyTotalItensRetorno = props.TotalItensRetorno
      ? `&TotalItensRetorno=${props.TotalItensRetorno}`
      : "";
    const LISTAR_CAROMETRO = `/identity/usuario/v1/carometro?${verifyIdUsuarioLider}${verifyPalavraChave}${verifyPaginaAtual}${verifyTotalItensRetorno}`;
    const response = await instance.get(LISTAR_CAROMETRO);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: [props.queryKey, props.IdUsuarioLider],
    refetchOnWindowFocus: false,
    enabled: props.enabled,
    retry: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar carometro. Motivos:\n ${error.response.data.notifications?.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
